import api from './api';

export interface DesktopInfo {
  embedUrl: string;
  connectionName: string;
  assigned: boolean;
  error?: string;
}

export interface StudentScreenInfo {
  available: boolean;
  embedUrl: string;
  connectionName: string;
}

export const guacamoleService = {
  async getDesktop(sessionId: string): Promise<DesktopInfo> {
    const response = await api.get(`/sessions/${sessionId}/desktop`);
    return response.data;
  },

  async getStudentScreen(sessionId: string, studentId: string): Promise<StudentScreenInfo> {
    const response = await api.get(`/sessions/${sessionId}/students/${studentId}/screen`);
    return response.data;
  },
};
